import { render, staticRenderFns } from "./SamplesScatter.vue?vue&type=template&id=79d00a52"
import script from "./SamplesScatter.vue?vue&type=script&lang=js"
export * from "./SamplesScatter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports